import Image from '@tiptap/extension-image';
import { Plugin, NodeSelection } from 'prosemirror-state';

const ImageWithAlign = Image.extend({
  addAttributes() {
    const base =
      (Image as any).config?.addAttributes
        ? (Image as any).config.addAttributes()
        : {};
    return {
      ...base,
      align: {
        default: null as string | null,
        parseHTML: (el: HTMLElement) => el.getAttribute('data-align') || null,
        renderHTML: (attrs: { align?: string | null }) =>
          attrs.align ? { 'data-align': attrs.align } : {},
      },
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handleClickOn(view, pos, node) {
            if (node.type.name === 'image') {
              view.dispatch(
                view.state.tr.setSelection(
                  NodeSelection.create(view.state.doc, pos)
                )
              );
              return true;
            }
            return false;
          },
        },
      }),
    ];
  },
});

export default ImageWithAlign;